module.exports = __webpack_public_path__ + "img/article-sport-kiwi-tip.a71a359c.png";